import { propertyValuesNormalizer } from '../normalizers/propertyValuesNormalizer'
import { YmAttrs } from "../../../contracts/Ym";

export const ymEventAdapter = (item): YmAttrs => {
  const { propertyValues, propertyValuesEnum } = item
  const { ymTarget } = propertyValuesNormalizer(propertyValues)
  const { ymId, ymMethod } = propertyValuesNormalizer(propertyValuesEnum)
  return {
    ymId,
    ymMethod,
    ymTarget,
  }
}
